import { type KnoxConfig } from '@/models/knox/KnoxConfig';
import { HttpError, getJwt } from '../common';

const BASE_URL = import.meta.env.VITE_API_URL;

// Brand-level Knox credential config, brand-scoped (PortalAPI guards brand ownership).
export const knoxConfigApi = {
    get: async (brandId: string): Promise<KnoxConfig | null> => {
        const response = await fetch(`${BASE_URL}/knox/config?brandId=${brandId}`, {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${getJwt()}`
            }
        });
        if (!response.ok) throw new HttpError(response.status, await response.text().catch(() => ''));
        return await response.json().catch(() => null); // null when the brand has no Knox config
    },
    save: async (brandId: string, config: KnoxConfig): Promise<void> => {
        const response = await fetch(`${BASE_URL}/knox/config?brandId=${brandId}`, {
            method: 'PUT',
            body: JSON.stringify(config),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${getJwt()}`
            }
        });
        if (!response.ok) throw new HttpError(response.status, await response.text().catch(() => ''));
    },
    remove: async (brandId: string): Promise<void> => {
        const response = await fetch(`${BASE_URL}/knox/config?brandId=${brandId}`, {
            method: 'DELETE',
            headers: {
                'Authorization': `Bearer ${getJwt()}`
            }
        });
        if (!response.ok) throw new HttpError(response.status, await response.text().catch(() => ''));
    }
};
